import { createAuthState } from "../types/auth-state/auth-state.functions";
import { AuthActions, AuthActionType } from "./auth.actions";
import { AuthState } from "../types/auth-state/auth-state.interface";

export function authReducer(state = createAuthState(), action: AuthActionType): AuthState {
  switch (action.type) {
    case AuthActions.AuthenticateSuccess:
      return {
        ...state,
        userId: action.payload,
      };
    case AuthActions.AuthenticateFailure:
      return {
        ...state,
        error: action.payload,
      };
    case AuthActions.DestroySession:
      return createAuthState();
    default:
      return state;
  }
}
